export const GRADE_STATUSES = {
	success: 'success.main',
	error: 'error',
	unknown: 'secondary',
	primary: 'primary.main',
	warning: 'warning.main',
};
